var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"error-wrapper",style:(_vm.customVuexStyles)},[_c('p',{staticClass:"error-message"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }